import React from "react";
import "./Features.css";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const Features = () => {
  const { ref, inView } = useInView({
    triggerOnce: true, // runs only once
    threshold: 0.3, // trigger when 30% visible
  });

  return (
    <section className="Features_section" ref={ref}>
      <div className="container">
        <div className="features_holder">
          <div className="row">

            {/* Average Package */}
            <div className="col-lg-3 col-md-3 col-sm-3 col-6 mb-2">
              <div className="features_div">
                <h4 className="features_number">
                  {inView && <CountUp end={12} duration={2} />} LPA
                </h4>
                <h5 className="features_text">AVERAGE PACKAGE</h5>
              </div>
            </div>

            {/* Salary Hike */}
            <div className="col-lg-3 col-md-3 col-sm-3 col-6 mb-2">
              <div className="features_div">
                <h4 className="features_number">
                  {inView && <CountUp end={120} duration={2} />}%
                </h4>
                <h5 className="features_text">AVG SALARY HIKE</h5>
              </div>
            </div>

            {/* Highest Package */}
            <div className="col-lg-3 col-md-3 col-sm-3 col-6 mb-2">
              <div className="features_div">
                <h4 className="features_number">
                  {inView && <CountUp end={58} duration={2} />} LPA
                </h4>
                <h5 className="features_text">HIGHEST PACKAGE</h5>
              </div>
            </div>

            {/* Highest Hike */}
            <div className="col-lg-3 col-md-3 col-sm-3 col-6 mb-2">
              <div className="features_div">
                <h4 className="features_number">
                  {inView && <CountUp end={300} duration={2} />}%
                </h4>
                <h5 className="features_text">HIGHEST HIKE</h5>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;